import React, { Component } from 'react';
import { Table, Space, PageHeader } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { EyeOutlined } from '@ant-design/icons';
import * as actions from '../redux/actions/agents';
import { CSVLink } from "react-csv";

class AgentList extends Component {
    handleAction = (id) => {
        this.props.onAction(id, this.props.token);
        this.props.history.push("/agentDetail");
    }
    render() {
        const dataSource = [];
        const headers = [
            { label: "Name", key: "name" },
            { label: "Phone", key: "mobile" },
            { label: "Balance", key: "balance" }
        ];
        this.props.agents.map(
            data => {
                let { balance } = data;
                let formattedBalance = `${balance}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                let item = {
                    ...data,
                    balance: formattedBalance
                };
                dataSource.push(item);
            }
        );

        const columns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                align:'center',
            },
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                align:'center',
            },
            {
                title: 'Mobile',
                dataIndex: 'mobile',
                key: 'mobile',
                align:'center',
            },
            {
                title: 'Balance',
                dataIndex: 'balance',
                key: 'balance',
                align: 'right',
            },
            {
                title: 'Action',
                dataIndex: 'action',
                align: 'center',
                render: (text, record) => (
                    <Space size="middle">
                        <a onClick={() => this.handleAction(record.id)}><EyeOutlined style={{ fontSize: '24px', color: '#08c' }} /></a>
                    </Space>
                ),
            },
        ];
        const downloadBtn = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '150px',
            height: '30px',
            backgroundColor: '#4a7297',
            color: 'white',
            border: 'none',
            outline: 'none',
            marginLeft: 'auto',
        }
        return (
            <>
                <PageHeader
                    className="site-page-header"
                    title="Agents"
                />
                <Table dataSource={dataSource} columns={columns} bordered />
                <CSVLink data={dataSource} headers={headers} filename={"agent-list.csv"} style={downloadBtn} target="_blank">
                    Download CSV
                </CSVLink>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        error: state.agents.error,
        loading: state.agents.loading,
        agents: state.agents.agents
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onAction: (id, token) => dispatch(actions.getAgentDetail(id, token)),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AgentList));